import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getProductDetailSucceed, requestFailure } from '../actions'

export function* getProductDetailSaga(
  productApi: {
    getProductDetail: (...args: any[]) => any
  },
  { payload: productId }: { payload: string }
) {
  try {
    const { data } = yield call(productApi.getProductDetail, productId)
    yield put(getProductDetailSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
